
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rekrutmen/[id]",
      function () {
        return require("private-next-pages/rekrutmen/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rekrutmen/[id]"])
      });
    }
  